<template>
		<div style="background-color:#F5F5F5;width:100%;">
			<!-- 主文 -->
			<div style="display:flex;justify-content: center;">
			<div style="background-color:#F5F5F5;display:flex;margin-top:10px;">
				<!-- 1 -->
				<!-- 2 -->
				<div style="background-color: #FFFFFF;margin-left:14px;width: 948px; padding-top:14px;position:relative;">
					<div style="display: flex;margin-left:14px;">
						<input v-model="title" type="text"  style="outline:none;width:353px;;height:25px;border-style:solid; border-width:1px; border-color:#20919D;" />
						<div class="serch" @click="serch()">搜索</div>
					</div>
					<div style="display: flex;justify-content: space-between;">
						<!-- 1 -->
						<div>
							<div style="display:flex;margin-left:14px;margin-top:31px;margin-bottom:56px;">
									<div >
										<div v-for="(item,index) in zp" :key="index">
											<a v-if="item.src!=''" :href="item.src" target="_blank"><img :class="(index==0?'':'imgbj')"   class="img" :src="urls+item.url" /></a>
											<a v-else><img :class="(index==0?'':'imgbj')"   class="img" :src="urls+item.url" /></a>
										</div>
									</div>
								<div class="font yerw">
									<div :class="(index!=0?'nmb':'')" class="font" v-for="(item,index) in dxb" :key="index" style="display:flex;align-items:center;">
										<img src="../assets/banner/6_03.gif" style="width:15px;height:15px;"/>
										<div v-if="item.src==''" @click="wztz(item.id)" class="font fontcolor" style="margin-left:5px;text-align:left;cursor:pointer;">{{item.title}}</div>
										<a v-else target="_blank" :href="item.src" class="font fontcolor" style="margin-left:5px;text-align:left;">{{item.title}}</a>
									</div>	
								</div>
							</div>
						</div>
						<div style="position:absolute;bottom:10px;right:10px;">
							<el-pagination
							  background
							  layout="prev, pager, next"
							  :total="totals" 
							@current-change="handleCurrentChange"
							  >
							</el-pagination>
						</div>
					</div>
				</div>
			</div>
			</div>
		</div>
</template>

<script>
	import axios from '../util/http.js'
	import base from '../util/base.js'
	export default {
		name:"Resource",
		components:{
		},
		data() {
			return {
				totals:null,//总条数 
				lastpage:'',//总页数
				page:'',//传参页
				pages:'',//当前页
				urls:'',
				title:'',
				pid:'',
				url:'https://www.baidu.com/',
				tabIndex:6,
				tabIndexs:0,
				activeName: '1',
				zp:'',
				dh:[
					{a:'首页'},
					{a:'活动'},
					{a:'研究'},
					{a:'学院'},
					{a:'人物视界'},
					{a:'融资并购'},
					{a:'转移转化'},
				],
				zx:'',
				dxb:[],
			}
		},
		created() {
					this.wenzhang()
					this.tup()
		},
		methods: {
			wztz:function(e){
				this.datalisid=e
				this.$router.push({path:'/Home/details',query:{data:this.datalisid,datas:9}});
			},
			handleCurrentChange(val){
				this.wenzhang(val)
			},
			serch:function(){
				this.wenzhang()
			},
			wenzhang:function(e){
				this.page=e
				//获取产品推荐文章
				axios({
				    url: `${base.url}/api/user/productNew`,
				    method: 'post',
				    data:{title:this.title,page:this.page}
				}).then((res) => {
					if(res.code==1){
						this.dxb=res.data.data
						this.urls=res.url
						//总条数
						 this.totals=Number(res.data.total)
						//总页数
						this.lastpage=res.data.last_page
						//当前页
						this.pages=res.data.current_page
					}
				        })
			},
			tup:function(){
				//获取产品推荐广告图
				axios({
				    url: `${base.url}/api/user/productActivity`,
				    method: 'post',
				    data:''
				}).then((res) => {
					if(res.code==1){
						this.zp=res.data
					}
				        })
			}
		},
	}
</script>

<style lang="scss" scoped>
	.font{
		font-size:0.875rem;
	}
	.color{
		color: #FFFFFF;
		width:135px;
		height:42px;
		line-height: 42px;
		text-align: center ;
	}
	.bjmagin{
		margin:0px 10px 0px;
	}
	.bjmagins{
		margin:0px 10px 0px 0px;
	}
	.img{
		width:138px;
		height:80px;
		cursor:pointer;
	}
	.serch{
		color:#FFFFFF;
		font-size:10px;
		background-color:#20919D;
		text-align:center;
		height: 29px;
		line-height:29px;
		width:50px;
	}
	.serch:hover{
		cursor:pointer;
	}
	.flex{
		display:flex;
	}
	.flexjust{
		justify-content: center;
	}
	.flexali{
		align-items: center;
	}
	.colorwhite{
		color: #FFFFFF;
	}
	.activeb{
		background-color:#B5B5B5 !important;
	}
	.activec{
		background-color:#E27265 !important;
	}
	.dhl{
		color:#FFFFFF;
		font-size:15px;
		justify-content: center;
		align-items: center;
		padding:0 20px;
	}
	.dhls{
		color:#FFFFFF;
		font-size:15px;
		background-color: #59D4CF;
		display:flex;
		justify-content: center;
		align-items: center;
		padding:0 20px;
	}
	.Line{
		width:1px;
		height: 14px;
		background-color:#FFFFFF;
	}
	.kes{
		font-size: 14px;
		margin-left:2px;
		margin-top:5px ;
		color:#848484;
	}
	.Lines{
		width:1px;
		height: 12px;
		background-color:#CCCCCC;
		margin:10px 5px 10px;
	}
	.font{
		font-size:14px;
	}
	.colortm{
		font-size: 12px; 
		opacity:0.2;
	}
	.fontcolor{
		color:#767676;
	}
	.fontcolor:hover{
	color:#20919D;
	}
	.has{
		margin-top:5px;
		margin-left:10px;
	}
	.hass{
		margin-top:5px;
	}
	.mas{
		width:13px;
		height: 2px;
		background-color: #5AD6CE;
		margin-top:5px;
	}
	.mass{
		width:13px;
		height: 2px;
		background-color: #38A5EC;
		margin-top:5px;
	}
	.masr{
		width:13px;
		height: 2px;
		background-color: #5AD6CE;
		margin-top:5px;
		margin-left:10px;
	}
	.hove{
		margin:10px 2% 10px; 
		width:96%;
		background-color:#EEEEEE;
		height:2px;
	}
	.yerw{
		margin-left: 20px;
	}
	.por{
		display:flex;
		flex-direction: column;
	}
	.nmb{
		margin-top:11px;
	}
	.imgbj{
		margin-top: 8px;
	}
	.bodyd:hover{
	background-color:#5AD6CE;
	}
	.bodyd{
		background-color:#20919D;
		width:80px;
		height:70px;
		flex-direction: column;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #FFFFFF;
	}
	.nvbc{
		background-color:#20919D;
		width: 94px;
		height: 116px;
	}
	.ggnm{
		width:298px;
		height:76px;
	}
	.iur{
		margin-left: 5px;
	}
	.bjtop{
		margin-top: 10px;
	}
	.bjleft{
		margin-left:10px;
	}
	.bjright{
		margin-right:10px;
	}
	.bjbottom{
		margin-bottom:10px;
	}
	.router-link-active {
	  text-decoration: none;
	}
	a {
	  text-decoration: none;
	}
	.el-pagination .is-background .el-pager li:not(.disabled) .active{
	    background-color:#999999 !important;
	    color: #FFF;
	}
</style>
